import React from 'react';
import { motion } from 'framer-motion';
import { JobCard } from './JobCard';
import type { Job } from '../../data/jobs';

interface JobListProps {
  jobs: Job[];
  onJobClick: (job: Job) => void;
}

export const JobList: React.FC<JobListProps> = ({ jobs, onJobClick }) => {
  if (jobs.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center py-16"
      >
        <div className="text-6xl mb-4">🔍</div>
        <h3 className="text-xl font-medium text-gray-800 mb-2">No positions found</h3>
        <p className="text-gray-600">Try adjusting your search or filter criteria</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="space-y-6"
    >
      {jobs.map((job, index) => (
        <JobCard
          key={job.id}
          job={job}
          onClick={() => onJobClick(job)}
          delay={0.1 * index}
        />
      ))}
    </motion.div>
  );
}; 